import {
  datePickerGetDayOptions,
  datePickerGetMonthOptions,
} from '../date-picker'

import { MAXIMUM_AGE, MIN_AGE } from './consts'

export interface DateEntry {
  text: string
  value: number
}

export const dateOfBirthGetDays = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const days = datePickerGetDayOptions()

  if (includePlaceholder) {
    days.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return days
}

export const dateOfBirthGetMonths = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const months = datePickerGetMonthOptions()

  if (includePlaceholder) {
    months.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return months
}

export const dateOfBirthGetYears = (
  placeholderText = '',
  includePlaceholder = false,
): DateEntry[] => {
  const currentYear = new Date().getFullYear()
  const yearsToCount = MAXIMUM_AGE - MIN_AGE + 1
  const years: DateEntry[] = Array.from({ length: yearsToCount })
    .keys()
    .map((year) => ({
      text: String(currentYear - year - MIN_AGE),
      value: currentYear - year - MIN_AGE,
    }))
    .toArray()

  if (includePlaceholder) {
    years.unshift({
      text: placeholderText,
      value: 0,
    })
  }

  return years
}
